import { motion } from "framer-motion";

// Main brand logo lives in the public folder, referenced by URL (CRA).
const logo = `${process.env.PUBLIC_URL}/logo1.png`;

// Nav items: label shown + section id to scroll to.
const NAV_ITEMS = [
  { label: "Home", id: "home" },
  { label: "Services", id: "services" },
  { label: "Work", id: "projects" },
  { label: "Games", id: "games" },
  { label: "Tech", id: "technologies" },
  { label: "Insights", id: "insights" },
  { label: "About", id: "about" },
  { label: "Contact", id: "contact" },
];

export default function Header({ menuOpen, setMenuOpen }) {
  return (
    <>
      <header className="header">
        <div className="header-left">
          <motion.div
            className="logo-container"
            animate={{ y: [0, -6, 0] }}
            transition={{ duration: 3, repeat: Infinity, ease: "easeInOut" }}
            whileHover={{ 
              scale: 1.1, 
              rotate: [0, -5, 5, 0],
              transition: { duration: 0.5 }
            }}
          >
            <img src={logo} alt="EmberByte Logo" className="logo" />
          </motion.div>
          <div className="brand-text">
            <span className="brand-small">EmberByte</span>
            <span className="brand-tagline">Digital Solutions</span>
          </div>
        </div>

        {/* Desktop Navigation */}
        <nav className="nav-desktop">
          {NAV_ITEMS.map((item) => (
            <a key={item.id} href={`#${item.id}`}>
              {item.label}
            </a>
          ))}
        </nav>

        {/* Mobile Hamburger */}
        <button
          className="hamburger-mobile"
          onClick={() => setMenuOpen(!menuOpen)}
        >
          <span></span>
          <span></span>
          <span></span>
        </button>
      </header>

      {/* Mobile Menu Overlay */}
      {menuOpen && (
        <>
          <div 
            className="mobile-overlay"
            onClick={() => setMenuOpen(false)}
          />
          <div className="mobile-menu">
            <button 
              className="mobile-close"
              onClick={() => setMenuOpen(false)}
            >
              ✕
            </button>
            {NAV_ITEMS.map((item) => (
              <a 
                key={item.id} 
                href={`#${item.id}`}
                onClick={() => setMenuOpen(false)}
              >
                {item.label}
              </a>
            ))}
          </div>
        </>
      )}
    </>
  );
}
